export default {
  numberView: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '100%',
    '&[data-tabbed-right=true]': { textAlign: 'right' }
  }
};
